import React from "react";
import HomeView from "./HomeView";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import { GC_USER_ID, GC_AUTH_TOKEN } from "./constants";
import { commitLocalUpdate } from "react-relay";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import Spinner from "./Spinner";
import AnalysePageContainerWrapper from "./AnalysePageContainerWrapper";
import ThemeProvider from "./contexts/ThemeContext";
import KeyPoints from "./components/KeyPoints";

const KeyPointsQuery = graphql`
	query KeyPointsContainer_KeyPoints_Query($postId: String) {
		postAnalytics(postId: $postId) {
            id
            post_id
            news_points
		}
	}
`;

// const request = getRequest(userDetailsQuery);
// const operation = createOperationDescriptor(request, {} /* variables */);
// const disposable = environment.retain(operation);

function createAuthDetails(id) {
	commitLocalUpdate(environment, store => {
		const record = store.getRoot().getLinkedRecord("settings");
		record.setValue(true, "isAuthenticated");
		record.setValue(id, "userId");
	});
}

function KeyPointsContainer(props) {
    const postId = props.postId

	return (
		<QueryRenderer
			environment={environment}
			fetchPolicy={"store-and-network"}
			query={KeyPointsQuery}
			variables={{ postId: postId}}
			render={({ error, props }) => {
				if (error) throw error;
				if (!props)
					return (
						<div>
							<Spinner isLoading={true} />
						</div>
					);
				return (
					<div>
						<ThemeProvider>
                            <KeyPoints data={props.postAnalytics} />
						</ThemeProvider>
					</div>
				);
			}}
		/>
	);
}

export default KeyPointsContainer;
